<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-flower-tulip" icon-small title="لیست تسویه ها" color="accent">
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="3">
					</v-col>
					<v-col cols="12" md="6">
						<date-navigator v-model="dateRange" :options="{ rangeMode: true }" />
					</v-col>
					<v-col cols="12" md="3" class="d-flex align-center justify-end">
						<v-btn color="primary" dark class="mx-1" @click="loadData">
							دریافت اطلاعات
						</v-btn>
						<export-excel :items="items" :headers="headers" :fileName="excelFileName">
						</export-excel>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
							single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :loading="loading" :headers="headers" :items="filteredItems"
							:footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search"
							class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td class="text-center">{{ row.item.amount.toString().toPriceFormat() }}</td>
									<td class="ltr text-center">{{ row.item.saveDate_Persian.date }} {{ row.item.saveDate_Persian.time }}
									</td>
									<td class="text-center">
										<div>{{ row.item.userLoan.loanModel.title }}</div>
										<div class="grey--text">شماره وام: {{ row.item.userLoan.code }}</div>
									</td>
									<td class="text-center">{{ row.item.userLoan.memberModel.fullName }}</td>
									<td class="text-center">{{ row.item.userLoan.amount.toString().toPriceFormat() }}</td>
									<td class="text-center">{{ row.item.userLoan.subAgentPrice.toString().toPriceFormat() }}</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'SponsorePaymentsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				selectedRequest: {},
				dialog: false,
				search: '',
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				headers: [
					{
						text: 'مبلغ واریز شده',
						align: 'center',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'تاریخ',
						align: 'center',
						sortable: true,
						value: 'saveDate_Persian',
					},
					{
						text: 'بابت',
						align: 'center',
						sortable: true,
						value: 'userLoan.loanModel.title',
					},
					{
						text: 'مشتری',
						align: 'center',
						sortable: true,
						value: 'userLoan.memberModel.fullName',
					},
					{
						text: 'مبلغ وام',
						align: 'center',
						sortable: true,
						value: 'userLoan.amount',
					},
					{
						text: 'سهم نماینده',
						align: 'center',
						sortable: true,
						value: 'userLoan.agentPrice',
					},
				],
				items: [],
				statuses: [],
				statusFilter: [],
				loading: false
			}
		},
		mounted() {
			this.loadData()
		},
		computed: {
			excelFileName() {
				let name = 'گزارش واریزی های اسپانسر'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!(this.statusFilter || []).length)
					return this.items
				let clonedItems = []
				clonedItems.push(...this.items)
				clonedItems = clonedItems.filter(x => this.statusFilter.indexOf(x.str_Status) > -1)
				return clonedItems
			}
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('agent/SubAgentTransaction/List?start=' + this.dateRange.start + '&end=' + this.dateRange.end, null)
					.then(response => {
						this.items = response
						this.statuses = [...new Set(response.map(x => x.str_Status))]
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			}
		},
	}
</script>
<style></style>
